import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ReactNotifications } from 'react-notifications-component';
import showNotification from '../component/Notification';
import baseURL from '../component/baseURL';
import ProfilePopup from '../component/ProfilePopup';
export default function Filter() {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isMobileFilterModalOpen, setIsMobileFilterModalOpen] = useState(false);
    const [userid, setUserid] = useState('');
    const [agentkey, setAgentkey] = useState('');
    const [agentID, setAgentID] = useState('');
    const [filterList, setFilterList] = useState([]);
    const [propertyTypes, setPropertyTypes] = useState([]);
    const [loadData, setLoadData] = useState(false);
    const [isLoadingFilters, setIsLoadingFilters] = useState(true);
    const [filterIdToDelete, setFilterIdToDelete] = useState(null);

    useEffect(() => {

        const userID = localStorage.getItem('userID');
        setUserid(userID);
        const agentkey = localStorage.getItem('agentKey');
        setAgentkey(agentkey);
        const agentid = localStorage.getItem('agentID');
        setAgentID(agentid);


        fetchFilters(userID, agentid);
    }, []);

    const openDeleteModal = (filterId) => {
        setFilterIdToDelete(filterId);
        setIsDeleteModalOpen(true);
    };

    const closeDeleteModal = () => {
        setIsDeleteModalOpen(false);
        setFilterIdToDelete(null);
    };

    const handleDeleteConfirm = () => {
        if (filterIdToDelete) {
            removeFilter(filterIdToDelete);
            closeDeleteModal();
        }
    };

    const openEditModal = () => {
        setIsEditModalOpen(true);
    };

    const closeEditModal = () => {
        setIsEditModalOpen(false);
    };

    const openMobileFilterModal = () => {
        setIsMobileFilterModalOpen(true);
    };

    const closeMobileFilterModal = () => {
        setIsMobileFilterModalOpen(false);
    };


    function fetchFilters(userID, agentid) {
        setIsLoadingFilters(true);
        // console.log('USER ID before filter fetch: ' + this.state.userID)
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("agent_id", agentid)
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        formdata.append("filter_type", 'pool')

        console.log(formdata);

        fetch(baseURL.URL + '/consumer_portfolio/fetch_filters', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                console.log('Fetch Filter Response')
                console.log(responseJson.response.user_pref);
                const myFilters = responseJson.response.user_pref
                const propTypes = responseJson.response.property_type
                if (responseJson.server.code === 200) {
                    // this.setState({ filterList: myFilters, propertyTypes: propTypes, loadData: true, })
                    setFilterList(myFilters);
                    setPropertyTypes(propTypes);
                    setLoadData(true);
                }
                else {
                    showNotification('Error', responseJson.server.message, 'danger')
                }
                setIsLoadingFilters(false);
            })
            .catch((error) => {
                console.log(error);
                setIsLoadingFilters(false);
            });
    }

    function fetchFiltersReload(userID, agentid) {
        // setIsLoadingFilters(true);
        // console.log('USER ID before filter fetch: ' + this.state.userID)
        let formdata = new FormData();
        formdata.append("user_id", userID)
        formdata.append("agent_id", agentid)
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        formdata.append("filter_type", 'pool')

        console.log(formdata);

        fetch(baseURL.URL + '/consumer_portfolio/fetch_filters', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                console.log('Fetch Filter Response')
                console.log(responseJson.response.user_pref);
                const myFilters = responseJson.response.user_pref
                const propTypes = responseJson.response.property_type
                if (responseJson.server.code === 200) {
                    // this.setState({ filterList: myFilters, propertyTypes: propTypes, loadData: true, })
                    setFilterList(myFilters);
                    setPropertyTypes(propTypes);
                    setLoadData(true);
                }
                else {
                    showNotification('Error', responseJson.server.message, 'danger')
                }
                // setIsLoadingFilters(false);
            })
            .catch((error) => {
                console.log(error);
                // setIsLoadingFilters(false);
            });
    }

    function removeFilter(filterid) {
        let formdata = new FormData();
        formdata.append("user_id", userid)
        formdata.append("key", '81dc9bdb52d04dc20036dbd8313ed055')
        formdata.append("filter_id", filterid)
        fetch(baseURL.URL + '/consumer_portfolio/delete_filter', {
            method: 'POST',
            body: formdata
        }).then((response) => response.json())
            .then((responseJson) => {
                const result = responseJson
                console.log(result)
                if (responseJson.server.code === 200) {
                    //   Toast.showWithGravity(responseJson.server.message, Toast.SHORT, Toast.BOTTOM)
                    showNotification('Success', responseJson.server.message, 'success');
                    // Refresh the filter list
                    fetchFiltersReload(userid, agentID);
                }
                else {
                    showNotification('Error', responseJson.server.message, 'danger');
                }
            })
            .catch((error) => {
                console.error(error);
                showNotification('Error', 'Something went wrong while deleting filter', 'danger');
            });
    }

    return (
        <>
            <ReactNotifications />
            <header className="mobile-filter-header">
                <div className="mobile-filter-header-left flex items-center gap-2">
                    {/* <button className="mobile-filter-back" aria-label="Back" onClick={() => navigate('/home')}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path d="M12.5 15L7.5 10L12.5 5" stroke="#0E0E0E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </button> */}
                    <h1 className="mobile-filter-title">{t('filter')}</h1>
                </div>
                <button className="btn-add-filter" aria-label="Add Filter" onClick={() => navigate('/add-filter')}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M12 5V19M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    {t('addFilter')}
                </button>

            </header>
            <main className="main-content">
                <div className="container">
                    <div className="filter-page-layout">
                        <section className="filter-section">
                            <div className="filter-header">
                                <h2 className="filter-title">{t('myFilter')}</h2>
                                <button className="btn-add-filter" aria-label="Add Filter" onClick={() => navigate('/add-filter')}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M12 5V19M5 12H19" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                    {t('addFilter')}
                                </button>
                            </div>

                            <div className="filter-content">
                                {isLoadingFilters ? (
                                    <div className='loading-filters' style={{
                                        textAlign: 'center',
                                        padding: '60px 20px',
                                        color: '#666',

                                    }}>
                                        <div style={{
                                            width: '50px',
                                            height: '50px',
                                            border: '4px solid #f3f3f3',
                                            borderTop: '4px solid #1C4CAF',
                                            borderRadius: '50%',
                                            animation: 'spin 1s linear infinite',
                                            margin: '0 auto 20px'
                                        }}></div>
                                        <h3 style={{ fontSize: '24px', marginBottom: '10px', color: '#333' }}>{t('loading')}</h3>
                                        <p style={{ fontSize: '16px', color: '#999' }}>{t('pleaseWaitWhileWeFetchTheFilters')}</p>
                                    </div>
                                ) : filterList.length === 0 ? (
                                    <div className='loading-filters' style={{
                                        textAlign: 'center',
                                        padding: '60px 20px',
                                        color: '#666'
                                    }}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none" style={{ margin: '0 auto 20px', opacity: 0.5 }}>
                                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" fill="currentColor" />
                                        </svg>
                                        <h3 style={{ fontSize: '24px', marginBottom: '10px', color: '#333' }}>{t('noFiltersFound')}</h3>
                                        <p style={{ fontSize: '16px', color: '#999' }}>{t('youHaveNotCreatedAnyFiltersYetClickAddFilterToCreateOne')}</p>
                                    </div>
                                ) : (
                                    <div className="filter-cards-wrapper">
                                        <div className="filter-cards">
                                            {filterList.map((filter, index) => (
                                                <div key={index} className="filter-card cursor-pointer" onClick={() => navigate('/filter-list', {
                                                    state: {
                                                        filterId: filter.filter_id
                                                    }
                                                })}>
                                                    {filter.portfolio_count > 0 && (
                                                        <div className='filter-count'>{filter.portfolio_count}</div>
                                                    )}
                                                    <div className="filter-card-header">
                                                        <h3 className="filter-card-title">{filter.filter_name}</h3>
                                                        <button className="filter-delete" aria-label="Delete filter" onClick={(e) => {
                                                            e.stopPropagation();
                                                            openDeleteModal(filter.filter_id);
                                                        }}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M10.5322 2.08325C9.76518 2.08325 9.14336 2.70507 9.14336 3.47214C9.14336 3.85567 8.83244 4.16659 8.44891 4.16659H8.33317H5.20817C4.63288 4.16659 4.1665 4.63296 4.1665 5.20825C4.1665 5.78354 4.63288 6.24992 5.20817 6.24992H8.33317H8.44891H16.5491H16.5508H16.6665H19.7915C20.3668 6.24992 20.8332 5.78354 20.8332 5.20825C20.8332 4.63296 20.3668 4.16659 19.7915 4.16659H16.5499C16.1668 4.16613 15.8563 3.8554 15.8563 3.47214C15.8563 2.70507 15.2345 2.08325 14.4674 2.08325H10.5322Z" fill="black" fillOpacity="0.35" />
                                                                <path fillRule="evenodd" clipRule="evenodd" d="M6.24967 8.33325C5.95837 8.33325 5.68038 8.45523 5.48313 8.6696C5.28589 8.88396 5.18741 9.17113 5.21161 9.46143L6.01449 19.096C6.19444 21.2555 7.99973 22.9166 10.1668 22.9166H14.8326C16.9997 22.9166 18.8049 21.2555 18.9849 19.096L19.7877 9.46143C19.812 9.17113 19.7134 8.88396 19.5162 8.6696C19.3189 8.45523 19.041 8.33325 18.7497 8.33325H6.24967Z" fill="black" fillOpacity="0.35" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                    <div className="filter-details">
                                                        <div className="filter-detail-item">
                                                            <span className="filter-detail-label">{t('propertyType')}</span>
                                                            <span className="filter-detail-value">{filter.property_type}</span>
                                                        </div>
                                                        <div className="filter-detail-item">
                                                            <span className="filter-detail-label">{t('city')}</span>
                                                            <span className="filter-detail-value">{filter.cities}</span>
                                                        </div>
                                                        <div className="filter-detail-item">
                                                            <span className="filter-detail-label">{t('country')}</span>
                                                            <span className="filter-detail-value">{filter.country_name}</span>
                                                        </div>
                                                    </div>
                                                    <button className="filter-edit" aria-label="Edit filter" onClick={(e) => {
                                                        e.stopPropagation();
                                                        navigate('/edit-filter', {
                                                            state: {
                                                                filterData: filter
                                                            }
                                                        });
                                                    }}>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
                                                            <path d="M4.76 18.81C4.76 18.81 4.84 18.81 4.87 18.81L7.8 18.54C8.21 18.5 8.59 18.32 8.88 18.03L19.94 6.96998C20.46 6.44998 20.75 5.75998 20.75 5.02998C20.75 4.29998 20.46 3.60998 19.94 3.08998L19.23 2.37998C18.19 1.33998 16.38 1.33998 15.34 2.37998L13.93 3.78998L4.29 13.43C4 13.72 3.82 14.1 3.79 14.51L3.52 17.44C3.49 17.81 3.62 18.17 3.88 18.44C4.12 18.68 4.43 18.81 4.76 18.81ZM17.29 3.06998C17.61 3.06998 17.93 3.18998 18.17 3.43998L18.88 4.14998C19.12 4.38998 19.25 4.69998 19.25 5.02998C19.25 5.35998 19.12 5.67998 18.88 5.90998L18 6.78998L15.53 4.31998L16.41 3.43998C16.65 3.19998 16.97 3.06998 17.29 3.06998ZM5.28 14.65C5.28 14.59 5.31 14.54 5.35 14.5L14.46 5.37998L16.93 7.84998L7.82 16.96C7.82 16.96 7.72 17.03 7.67 17.03L5.04 17.27L5.28 14.64V14.65ZM22.75 22C22.75 22.41 22.41 22.75 22 22.75H2C1.59 22.75 1.25 22.41 1.25 22C1.25 21.59 1.59 21.25 2 21.25H22C22.41 21.25 22.75 21.59 22.75 22Z" fill="white" />
                                                        </svg>
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </section>
                    </div>
                </div >
            </main >

            <ProfilePopup />
            {/* <!-- Filter Edit Modal --> */}
            {
                isEditModalOpen && (
                    <div className="filter-edit-modal" id="filterEditModal">
                        <div className="filter-edit-modal-overlay" onClick={closeEditModal}></div>
                        <div className="filter-edit-modal-content">
                            <div className="filter-edit-modal-header">
                                <h2 className="filter-edit-modal-title">{t('editFilter')}</h2>
                                <button className="filter-edit-modal-close" id="filterEditModalClose" aria-label="Close" onClick={closeEditModal}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path d="M18 6L6 18M6 6L18 18" stroke="#0E0E0E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    </svg>
                                </button>
                            </div>

                            <div className="filter-edit-modal-body">
                                <div className="panel-section">
                                    <h3 className="panel-heading">{t('portfolioFilter')}</h3>
                                    <input type="text" className="filter-input" id="editFilterName" placeholder="Enter Filter Name" />
                                </div>

                                <div className="panel-section">
                                    <h3 className="panel-heading">{t('propertyType')}</h3>
                                    <div className="checkbox-group two-column">
                                        <label className="checkbox-label">
                                            <input type="checkbox" name="editPropertyType" value="All" />
                                            <span>All</span>
                                        </label>
                                        <label className="checkbox-label">
                                            <input type="checkbox" name="editPropertyType" value="Single Family Home" />
                                            <span>Single Family Home</span>
                                        </label>
                                        <label className="checkbox-label">
                                            <input type="checkbox" name="editPropertyType" value="Lot/Land" />
                                            <span>Lot/Land</span>
                                        </label>
                                        <label className="checkbox-label">
                                            <input type="checkbox" name="editPropertyType" value="Condo/Apartment" />
                                            <span>Condo/Apartment</span>
                                        </label>
                                        <label className="checkbox-label">
                                            <input type="checkbox" name="editPropertyType" value="Multi Family Home" />
                                            <span>Multi Family Home</span>
                                        </label>
                                        <label className="checkbox-label">
                                            <input type="checkbox" name="editPropertyType" value="Mobile/Manufactured" />
                                            <span>Mobile/Manufactured</span>
                                        </label>
                                        <label className="checkbox-label">
                                            <input type="checkbox" name="editPropertyType" value="Commercial" />
                                            <span>Commercial</span>
                                        </label>
                                    </div>
                                </div>

                                <div className="panel-section">
                                    <h3 className="panel-heading">Location</h3>
                                    <div className="dropdown-group">
                                        <select className="filter-dropdown" id="editCountry">
                                            <option value="">Country</option>
                                            <option value="Belgium">Belgium</option>
                                        </select>
                                        <select className="filter-dropdown" id="editState">
                                            <option value="">State</option>
                                            <option value="Brabant">Brabant</option>
                                        </select>
                                        <select className="filter-dropdown" id="editCity">
                                            <option value="">City</option>
                                            <option value="Antwerp">Antwerp</option>
                                            <option value="Anderlecht">Anderlecht</option>
                                        </select>
                                    </div>
                                </div>

                                <div className="panel-section">
                                    <h3 className="panel-heading">Price</h3>
                                    <div className="price-inputs">
                                        <input type="text" className="filter-input" id="editMinPrice" placeholder="Min Value" />
                                        <input type="text" className="filter-input" id="editMaxPrice" placeholder="Max Value" />
                                    </div>
                                </div>

                                <div className="panel-section">
                                    <h3 className="panel-heading">Bedrooms</h3>
                                    <div className="option-buttons" id="editBedrooms">
                                        <button type="button" className="option-btn active" data-value="All">All</button>
                                        <button type="button" className="option-btn" data-value="1">1</button>
                                        <button type="button" className="option-btn" data-value="2">2</button>
                                        <button type="button" className="option-btn" data-value="3">3</button>
                                        <button type="button" className="option-btn" data-value="4">4</button>
                                        <button type="button" className="option-btn" data-value="5">5</button>
                                    </div>
                                </div>

                                <div className="panel-section">
                                    <h3 className="panel-heading">Bathrooms</h3>
                                    <div className="option-buttons" id="editBathrooms">
                                        <button type="button" className="option-btn active" data-value="All">All</button>
                                        <button type="button" className="option-btn" data-value="1">1</button>
                                        <button type="button" className="option-btn" data-value="2">2</button>
                                        <button type="button" className="option-btn" data-value="3">3</button>
                                        <button type="button" className="option-btn" data-value="4">4</button>
                                        <button type="button" className="option-btn" data-value="5">5</button>
                                    </div>
                                </div>

                                <div className="panel-section">
                                    <h3 className="panel-heading">Garage</h3>
                                    <div className="option-buttons" id="editGarage">
                                        <button type="button" className="option-btn active" data-value="All">All</button>
                                        <button type="button" className="option-btn" data-value="1">1</button>
                                        <button type="button" className="option-btn" data-value="2">2</button>
                                        <button type="button" className="option-btn" data-value="3">3</button>
                                        <button type="button" className="option-btn" data-value="4">4</button>
                                        <button type="button" className="option-btn" data-value="5">5</button>
                                    </div>
                                </div>
                            </div>

                            <div className="filter-edit-modal-actions">
                                <button className="btn-secondary" id="editCancelBtn" onClick={closeEditModal}>Cancel</button>
                                <button className="btn-primary" id="editSaveBtn">Save Changes</button>
                            </div>
                        </div>
                    </div>
                )
            }

            {/* <!-- Delete Confirmation Modal --> */}
            {
                isDeleteModalOpen && (
                    <div className="delete-filter-modal" id="deleteFilterModal">
                        <div className="modal-overlay" onClick={closeDeleteModal}></div>
                        <div className="logout-modal">
                            <div className="delete-filter-modal-header justify-center">
                                <h2 className="delete-filter-modal-title text-center text-white">Delete Filter</h2>

                            </div>

                            <div className="delete-filter-modal-body">
                                <p className="delete-filter-message">Are you sure you want to delete this filter?</p>

                            </div>

                            <div className="btn-sec">
                                <button className="cancel-btn custom-btn" id="deleteFilterCancelBtn" onClick={closeDeleteModal}>Cancel</button>
                                <button className="save-btn custom-btn" id="deleteFilterConfirmBtn" onClick={handleDeleteConfirm}>Yes</button>
                            </div>
                        </div>
                    </div>
                )
            }

            {/* <!-- Mobile Filter Modal --> */}
            {
                isMobileFilterModalOpen && (
                    <div className="mobile-filter-modal" id="mobileFilterModal">
                        <div className="mobile-filter-modal-header">
                            <button className="mobile-filter-modal-back" id="mobileFilterModalBack" onClick={closeMobileFilterModal}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="24" viewBox="0 0 14 24" fill="none">
                                    <path d="M11.668 23.2341C11.4486 23.2354 11.2312 23.1933 11.0281 23.1104C10.8251 23.0274 10.6404 22.9052 10.4847 22.7508L0.484654 12.7508C0.174236 12.4385 0 12.0161 0 11.5758C0 11.1355 0.174236 10.713 0.484654 10.4008L10.4847 0.400762C10.8035 0.127718 11.2136 -0.014959 11.6331 0.00124297C12.0525 0.0174449 12.4504 0.191331 12.7473 0.488156C13.0441 0.78498 13.218 1.18288 13.2342 1.60234C13.2504 2.0218 13.1077 2.43193 12.8347 2.75076L4.01799 11.5674L12.8347 20.3841C13.0687 20.6162 13.2286 20.9125 13.2943 21.2355C13.3599 21.5586 13.3283 21.8938 13.2034 22.1989C13.0786 22.5039 12.866 22.7651 12.5927 22.9494C12.3194 23.1336 11.9976 23.2327 11.668 23.2341Z" fill="black" />
                                </svg>
                            </button>
                            <h2 className="mobile-filter-modal-title">Add Filter</h2>
                            <div></div> {/* <!-- Spacer for alignment --> */}
                        </div>

                        <div className="mobile-filter-modal-content">
                            <div className="panel-section">
                                <h3 className="panel-heading">Portfolio Filter</h3>
                                <input type="text" className="filter-input" placeholder="Enter Filter Name" />
                            </div>

                            <div className="panel-section">
                                <h3 className="panel-heading">Property Type</h3>
                                <div className="checkbox-group two-column">
                                    <label className="checkbox-label">
                                        <input type="checkbox" />
                                        <span>All</span>
                                    </label>
                                    <label className="checkbox-label">
                                        <input type="checkbox" />
                                        <span>Single Family Home</span>
                                    </label>
                                    <label className="checkbox-label">
                                        <input type="checkbox" />
                                        <span>Lot/Land</span>
                                    </label>
                                    <label className="checkbox-label">
                                        <input type="checkbox" />
                                        <span>Condo/Apartment</span>
                                    </label>
                                    <label className="checkbox-label">
                                        <input type="checkbox" />
                                        <span>Multi Family Home</span>
                                    </label>
                                    <label className="checkbox-label">
                                        <input type="checkbox" />
                                        <span>Mobile/Manufatored</span>
                                    </label>
                                    <label className="checkbox-label">
                                        <input type="checkbox" />
                                        <span>Commercial</span>
                                    </label>
                                </div>
                            </div>

                            <div className="panel-section">
                                <h3 className="panel-heading">Location</h3>
                                <div className="dropdown-group">
                                    <select className="filter-dropdown">
                                        <option>Country</option>
                                    </select>
                                    <select className="filter-dropdown">
                                        <option>State</option>
                                    </select>
                                    <select className="filter-dropdown">
                                        <option>City</option>
                                    </select>
                                </div>
                            </div>

                            <div className="panel-section">
                                <h3 className="panel-heading">Price</h3>
                                <div className="price-inputs">
                                    <input type="text" className="filter-input" placeholder="Min Value" />
                                    <input type="text" className="filter-input" placeholder="Max Value" />
                                </div>
                            </div>

                            <div className="panel-section">
                                <h3 className="panel-heading">Bedrooms</h3>
                                <div className="option-buttons">
                                    <button className="option-btn active">All</button>
                                    <button className="option-btn">1</button>
                                    <button className="option-btn">2</button>
                                    <button className="option-btn">3</button>
                                    <button className="option-btn">4</button>
                                    <button className="option-btn">5</button>
                                </div>
                            </div>

                            <div className="panel-section">
                                <h3 className="panel-heading">Bathrooms</h3>
                                <div className="option-buttons">
                                    <button className="option-btn active">All</button>
                                    <button className="option-btn">1</button>
                                    <button className="option-btn">2</button>
                                    <button className="option-btn">3</button>
                                    <button className="option-btn">4</button>
                                    <button className="option-btn">5</button>
                                </div>
                            </div>

                            <div className="panel-section">
                                <h3 className="panel-heading">Garage</h3>
                                <div className="option-buttons">
                                    <button className="option-btn active">All</button>
                                    <button className="option-btn">1</button>
                                    <button className="option-btn">2</button>
                                    <button className="option-btn">3</button>
                                    <button className="option-btn">4</button>
                                    <button className="option-btn">5</button>
                                </div>
                            </div>
                        </div>

                        <div className="mobile-filter-modal-actions">
                            <button className="btn-clear">Clear all</button>
                            <button className="btn-apply" onClick={closeMobileFilterModal}>Apply</button>
                        </div>
                    </div>
                )
            }
        </>
    );
}